import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Paper,
  Table,
  TableBody,
  TableContainer,
} from '@mui/material';
import { useSelector } from 'react-redux';
import useShortcuts from '../../hooks/shortcuts/useShortcuts';
import {
  StyledTableCell,
  StyledTableHead,
  StyledTableRow,
} from '../../helpers/themes/TableTheme';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import SaveIcon from '@mui/icons-material/Save';
import useUpdateShortcuts from '../../hooks/shortcuts/useUpdateShortcuts';
import EastIcon from '@mui/icons-material/East';
import KeyboardReturnOutlinedIcon from '@mui/icons-material/KeyboardReturnOutlined';
import { ShortcutTable } from './ShortcutTable';

export const Shortcuts = () => {
  const profile = useSelector((state) => state?.login?.profile);
  const { data, mutate } = useShortcuts(profile?._id?.toString());
  const { updateShortcut } = useUpdateShortcuts();
  const [isAdd, setIsAdd] = useState(false);
  const [isRemove, setIsRemove] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [addError, setAddError] = useState(false);
  const [newShortcut, setNewShortcut] = useState({
    label: null,
    content: null,
  });

  const handleAddShortcuts = () => {
    if (!newShortcut?.label || !newShortcut?.content) {
      setAddError(true);
      return;
    }
    if (data?.shortcuts?.some((item) => item?.label === newShortcut?.label)) {
      setAddError(true);
      return;
    }
    setAddError(false);
    const tmp = data?.shortcuts || [];
    const updateData = {
      profile: profile?._id,
      shortcuts: [...tmp, newShortcut],
    };
    updateShortcut(updateData);
    setNewShortcut({
      label: null,
      content: null,
    });
    setIsAdd(!isAdd);
  };

  const handleCancelShortcuts = () => {
    setAddError(false);
    setNewShortcut({
      label: null,
      content: null,
    });
    setIsAdd(!isAdd);
  };

  const handleDeleteShortcuts = (id) => {
    setIsRemove(false);
    const shortcutList = data?.shortcuts?.filter(
      (item) => item?._id?.toString() !== id?.toString()
    );
    const updateData = {
      profile: profile?._id,
      shortcuts: shortcutList,
    };
    updateShortcut(updateData);
    setIsRemove(!isRemove);
  };

  const handleUpdateShortcuts = (update) => {
    setIsEdit(false);
    const shortcutList = data?.shortcuts?.map((item) => {
      if (item?._id?.toString() === update?._id?.toString()) {
        return update;
      }
      return item;
    });

    const updateData = {
      profile: profile?._id,
      shortcuts: shortcutList,
    };
    updateShortcut(updateData);
    setIsEdit(!isEdit);
  };

  useEffect(() => {
    mutate();
  }, [profile, isAdd, isRemove, isEdit]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        margin: 2,
        gap: 2,
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <TableContainer component={Paper}>
          <Table>
            <StyledTableHead>
              <StyledTableRow>
                <StyledTableCell align="center" sx={{ width: '35%' }}>
                  Raccourcis
                </StyledTableCell>
                <StyledTableCell align="center" sx={{ width: '10%' }}>
                  <EastIcon />
                </StyledTableCell>
                <StyledTableCell align="center" sx={{ width: '35%' }}>
                  Texte
                </StyledTableCell>
                <StyledTableCell />
              </StyledTableRow>
            </StyledTableHead>
            <TableBody>
              <ShortcutTable
                data={data}
                onDelete={(id) => handleDeleteShortcuts(id)}
                onEdit={(update) => handleUpdateShortcuts(update)}
                isAdd={isAdd}
                newShortcut={newShortcut}
                setNewShortcut={setNewShortcut}
                addError={addError}
              />
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
      <Box
        sx={{ display: 'flex', width: '100%', justifyContent: 'space-evenly' }}
      >
        {isAdd ? (
          <>
            <Button
              size="large"
              color="info"
              onClick={handleCancelShortcuts}
              startIcon={<KeyboardReturnOutlinedIcon fontSize="large" />}
            >
              Retour
            </Button>
            <Button
              size="large"
              color="success"
              onClick={handleAddShortcuts}
              startIcon={<SaveIcon fontSize="large" />}
            >
              Enregistrer
            </Button>
          </>
        ) : (
          <Button
            size="large"
            onClick={() => setIsAdd(true)}
            startIcon={<AddCircleOutlineIcon fontSize="large" />}
          >
            Ajouter un raccourci
          </Button>
        )}
      </Box>
    </Box>
  );
};
